import { dark } from '../dark'

export const madroxColors = {
  // Primary
  'primary-100': dark['primary-100'],
  'primary-200': dark['primary-200'],
  'primary-300': dark['primary-300'],
  'primary-400': dark['primary-400'],

  // Secondary
  'secondary-100': dark['secondary-100'],
  'secondary-200': dark['secondary-200'],
  'secondary-300': dark['secondary-300'],
  'secondary-400': dark['secondary-400'],

  // Background
  'background-100': dark['background-100'],

  // Neutral
  'neutral-0': dark['neutral-0'],
  'neutral-100': dark['neutral-100'],
  'neutral-200': dark['neutral-200'],
  'neutral-300': dark['neutral-300'],
  'neutral-400': dark['neutral-400'],
  'neutral-500': dark['neutral-500'],
  'neutral-600': dark['neutral-600'],
  'neutral-700': dark['neutral-700'],
  'neutral-800': dark['neutral-800'],

  // Success
  'success-100': dark['success-100'],
  'success-200': dark['success-200'],
  'success-300': dark['success-300'],
  'success-400': dark['success-400'],

  // Info
  'info-100': dark['info-100'],
  'info-200': dark['info-200'],
  'info-300': dark['info-300'],
  'info-400': dark['info-400'],

  // Warning
  'warning-100': dark['warning-100'],
  'warning-200': dark['warning-200'],
  'warning-300': dark['warning-300'],
  'warning-400': dark['warning-400'],

  // Danger
  'danger-100': dark['danger-100'],
  'danger-200': dark['danger-200'],
  'danger-300': dark['danger-300'],
  'danger-400': dark['danger-400'],
}
